import "./SectionReclamarEnColombia.css";
import logo from "./img/logos_colombia.png";
import imgEfecty from "./img/Logo_efecty.png";
import imgBancoAgrario from "./img/Logo_BancoAgrario.png";
import imgMultipagas from "./img/LogoMultipagas.png";
import imgPuntoRed from "./img/Logo_PuntoRed.png";
import imgCoopenessa from "./img/Logo_Coopenessa.png";
import imgCFA from "./img/Logo_CFA.png";

function SectioReclamarEnColombia() {
  return (
    <div>
      <div className="row p-0 container_sectionReclamarColombia mx-0">
        <div className="col-12 col-lg-6 bg_white d-flex justify-content-center pt-5">
          <div>
            <p className="h2 museoSans black">
              ¿Cómo reclamar un
              <br />
              <span className="bg_yellow">Giro en Colombia?</span>
            </p>
          </div>
        </div>

        <div
          className="container_pasos position-absolute end-0 start-0 row mx-auto
                 px-lg-0 gap-4 justify-content-center"
        >
          <div className="col-12 col-lg bg_soft_grey container_paso border_cards">
            <div className="container_content_paso">
              <p className="museoSans700 h3 mb-4 d-none d-lg-block">
                Para hacerlo, <br />
                necesitas:
              </p>
              <p className="museoSans700 h3 mb-4 d-lg-none">
                Para hacerlo, necesitas:
              </p>
              <div className="row gap-3">
                <div className="col-12  d-flex align-items-center">
                  <div>
                    <div className="rounded-circle container_circular bg_yellow">
                      <p className="mb-0 font_size_angle_breakets">
                        <strong>&gt;</strong>
                      </p>
                    </div>
                  </div>
                  <p className="mb-0 ps-2">Código MTCN</p>
                </div>
                <div className="col-12 d-flex align-items-center">
                  <div>
                    <div className="rounded-circle container_circular bg_yellow">
                      <p className="mb-0 font_size_angle_breakets">
                        <strong>&gt;</strong>
                      </p>
                    </div>
                  </div>
                  <p className="mb-0 ps-2">Nombre completo del remitente</p>
                </div>
                <div className="col-12 d-flex align-items-center">
                  <div>
                    <div className="rounded-circle container_circular bg_yellow">
                      <p className="mb-0 font_size_angle_breakets">
                        <strong>&gt;</strong>
                      </p>
                    </div>
                  </div>
                  <p className="mb-0 ps-2">País desde donde envían</p>
                </div>
                <div className="col-12 d-flex align-items-center">
                  <div>
                    <div className="rounded-circle container_circular bg_yellow">
                      <p className="mb-0 font_size_angle_breakets">
                        <strong>&gt;</strong>
                      </p>
                    </div>
                  </div>
                  <p className="mb-0 ps-2">Valor del Giro</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg bg_soft_grey container_paso border_cards">
            <div className="container_content_paso">
              <p className="museoSans700 h3 mb-4">Hazlo a través de:</p>
              <div className="row gap-3">
                <div className="col-12  d-flex align-items-center">
                  <div>
                    <div className="rounded-circle container_circular bg_yellow">
                      <p className="mb-0 font_size_angle_breakets">
                        <strong>&gt;</strong>
                      </p>
                    </div>
                  </div>
                  <p className="mb-0 ps-2">Nuestras oficinas</p>
                </div>
                <div className="col-12 d-flex align-items-center container_ovf_wrap">
                  <div>
                    <div className="rounded-circle container_circular bg_yellow">
                      <p className="mb-0 font_size_angle_breakets">
                        <strong>&gt;</strong>
                      </p>
                    </div>
                  </div>
                  <p className="mb-0 ps-2">
                    Portal web
                    <br />
                    <strong>
                      <a
                        href="https://www.bancounion.com"
                        className="text-decoration-none black"
                        target="_blank"
                        rel="noreferrer"
                      >
                        www.bancounion.com
                      </a>
                    </strong>
                  </p>
                </div>
                <div className="col-12 d-flex align-items-center">
                  <div>
                    <div className="rounded-circle container_circular bg_yellow">
                      <p className="mb-0 font_size_angle_breakets">
                        <strong>&gt;</strong>
                      </p>
                    </div>
                  </div>
                  <p className="mb-0 ps-2">
                    Línea nacional
                    <strong> 01 8000 111 999</strong>
                  </p>
                </div>

                <p className="font_size_recuerda">
                  <span className="font_oblique">
                    Recuerda que puedes Cobrar tus Giros en
                    <br />
                    Colombia, combinando diferentes medios de
                    <br />
                    pago:{" "}
                  </span>
                  <strong>efectivo, cheque y abono en cuenta.</strong>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg bg_soft_grey container_paso border_cards">
            <div className="container_content_paso">
              <p className="museoSans700 h3 mb-4">
                En nuestros
                <br />
                Corresponsales, en más de 850 ciudades:
              </p>

              <p style={{ fontStyle: "italic" }}>
                Haz click en cada corresponsal y conoce sus oficinas
              </p>

              <div class="ContainerLogosC">
                <div class="Efecty">
                  <a
                    href="https://bancounion.com/wps/wcm/connect/bancounion/c1fc53e2-fd7b-4a28-bc4f-95c30f3780b1/OFICINAS%2BEFECTY.pdf?MOD=AJPERES&CVID=obMqL5f&CVID=obMqL5f&CVID=obMqL5f&CVID=obMqL5f"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="img-fluid"
                      src={imgEfecty}
                      alt="Logos de corresponsales"
                    />
                  </a>
                </div>
                <div class="BancoAgrario">
                  <a href="https://bancounion.com/wps/wcm/connect/bancounion/ba0bf668-8dbf-468d-96c3-d6a4288dcb88/OFICINAS%2BBANCO%2BAGRARIO.pdf?MOD=AJPERES&CVID=obMqC.W&CVID=obMqC.W&CVID=obMqC.W&CVID=obMqC.W" target="_blank" rel="noreferrer">
                    <img
                      className="img-fluid"
                      src={imgBancoAgrario}
                      alt="Logos de corresponsales"
                    />
                  </a>
                </div>
                <div class="Multipagas">
                  <a href="https://bancounion.com/wps/wcm/connect/bancounion/0ef9cfdc-66c5-4417-868f-74e9ab08819c/OFICINAS%2BMULTIPAGAS.pdf?MOD=AJPERES&CVID=obMqyAw&CVID=obMqyAw&CVID=obMqyAw&CVID=obMqyAw" target="_blank" rel="noreferrer">
                    <img
                      className="img-fluid"
                      src={imgMultipagas}
                      alt="Logos de corresponsales"
                    />
                  </a>
                </div>
                <div class="puntored">
                  <a href="https://bancounion.com/wps/wcm/connect/bancounion/e56ab51d-49d8-49fb-a40c-f35e85e5145e/OFICINAS%2BPUNTO%2BRED.pdf?MOD=AJPERES&CVID=obMqGDQ&CVID=obMqGDQ&CVID=obMqGDQ&CVID=obMqGDQ" target="_blank" rel="noreferrer">
                    <img
                      className="img-fluid"
                      src={imgPuntoRed}
                      alt="Logos de corresponsales"
                    />
                  </a>
                </div>
                <div class="Coopenesa">
                  <a href="https://bancounion.com/wps/wcm/connect/bancounion/7ccee218-c99d-400d-9f2b-7011fa7c5183/OFICINAS%2BCoopenesa.pdf?MOD=AJPERES&CVID=obMqtHW&CVID=obMqtHW&CVID=obMqtHW&CVID=obMqtHW" target="_blank" rel="noreferrer">
                    <img
                      className="img-fluid"
                      src={imgCoopenessa}
                      alt="Logos de corresponsales"
                    />
                  </a>
                </div>
                <div class="CFA">
                  <a href="https://bancounion.com/wps/wcm/connect/bancounion/98012fce-a4f1-4990-9179-2785fd34194e/OFICINAS+CFA.pdf?MOD=AJPERES&CVID=obMqqYm&CVID=obMqqYm&CVID=obMqqYm&CVID=obMqqYm" target="_blank" rel="noreferrer">
                    <img
                      className="img-fluid"
                      src={imgCFA}
                      alt="Logos de corresponsales"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-6 bg_yellow"></div>
      </div>
    </div>
  );
}

export default SectioReclamarEnColombia;
